<!--头像 -->
<template>
  <div class="personal-avatar">
    <zlr-modal v-model="uplpadShow">
      <div class="personal-avatar-con">
        <h1>上传头像</h1>
        <p>只能上传3MB大小以下的文件，格式显示为Jpg、PNG、Gif</p>
        <upload :format="['jpg', 'png', 'gif']"
                :secret=false
                :size=3
                path="head"
                on-error="uploadError"
                v-model="upload"></upload>
        <div class="personal-avatar-btn">
          <Button class="zlr-btn-default"
                  @click="uplpadShow= false">关闭</Button>
          <Button class="zlr-btn-primary"
                  @click="nextHandle"
                  :disabled="!upload">下一步</Button>
        </div>
      </div>
    </zlr-modal>
    <zlr-modal v-model="previewShow">
      <div class="personal-avatar-con">
        <h1>预览头像</h1>
        <div class="personal-avatar-preview">
          <img :src="upload"
               alt="">
          <div class="personal-avatar-preview-btn">
            <Button class="zlr-btn-default"
                    @click="previewShow= false">关闭</Button>
            <Button class="zlr-btn-primary"
                    @click="subHandle"
                    :loading="isSub"
                    :disabled="!upload">确定</Button>
          </div>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// api
import { saveModifyHead } from '@/api/info'
// images
import menteeAvatar from '@/assets/images/home/mentee-avatar.svg'
// componnets
import ZlrModal from '_c/modal/modal'
import Upload from '_c/upload/upload'
import { mapMutations } from 'vuex'
export default {
  name: 'personal-avatar',
  components: {
    ZlrModal,
    Upload
  },
  data () {
    return {
      uplpadShow: false,
      previewShow: false,
      isSub: false,
      menteeAvatar,
      upErrorMsg: '',
      upload: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    ...mapMutations(['setUserAvatar']),
    uplpadShowHandle () {
      this.upload = ''
      this.uplpadShow = true
    },
    // 下一步
    nextHandle () {
      this.uplpadShow = false
      this.previewShow = true
    },
    // 保存头像
    subHandle () {
      let data = {
        headPortrait: this.upload
      }
      this.isSub = true
      saveModifyHead(data).then(res => {
        this.$zlr_message('保存成功', 'success')
        this.previewShow = false
        this.setUserAvatar(this.upload)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(res => {
        this.isSub = false
      })
    },
    // 上传错误
    uploadError () {
    }
  }
}
</script>
<style lang='less' scoped>
</style>
